import { IconButton, TableCell } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import React, { useState } from 'react';
import ConfirmationModal from 'src/components/ConfirmationModal';
import { EsgDmaSubSubTopicOutSchema } from '../types';
import { useEsgSubSubTopic } from '../hooks';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from 'react-query';

export default function DeleteCustomSubSubtopicCell(props: {
  subsubtopic: EsgDmaSubSubTopicOutSchema;
}) {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
  const { _delete } = useEsgSubSubTopic({}, { enabled: false });

  if (props.subsubtopic.esg_dma_id === null) return null;

  return (
    <>
      <TableCell>
        <IconButton onClick={() => setDeleteConfirmationOpen(true)}>
          <DeleteIcon />
        </IconButton>
      </TableCell>

      <ConfirmationModal
        open={deleteConfirmationOpen}
        onClose={() => setDeleteConfirmationOpen(false)}
        onFalse={() => setDeleteConfirmationOpen(false)}
        onTrue={() =>
          _delete
            .mutateAsync(props.subsubtopic.id)
            .then(() => queryClient.invalidateQueries('dmaHierarchy'))
        }
        titleKey={t('esg:dma.tableV2.removeSubtopic')}
      />
    </>
  );
}
